jQuery(document).ready(function($){
    if ( $('.homepage-hero__slider').length > 0 ) {
        $('.homepage-hero__slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            appendArrows: $('.homepage-hero__slider__arrows'),
            prevArrow: '<button><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.46875 15.4375L9.8125 14.125L4.5625 8.875H21V7H4.5625L9.84375 1.71875L8.5 0.40625L0.96875 7.9375L8.46875 15.4375Z" fill="#D6E5FF"></path></svg></button>',
            nextArrow: '<button><svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5312 15.4375L11.1875 14.125L16.4375 8.875H0V7H16.4375L11.1562 1.71875L12.5 0.40625L20.0312 7.9375L12.5312 15.4375Z" fill="#D6E5FF"></path></svg></button>',
        });
    }

    $('.homepage-hero__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.homepage-hero__slider__nav div').removeClass('active');
        $('.homepage-hero__slider__nav div').eq(nextSlide).addClass('active');
    });

    $('.homepage-hero__slider__nav__item').on('click', function(){
        const slide_id = $(this).index();
        $('.homepage-hero__slider').slick( 'slickGoTo', slide_id );
    });
});